"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var view_models_1 = require("./../view-models");
var IncludedCoverageComponent = (function () {
    function IncludedCoverageComponent() {
    }
    return IncludedCoverageComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", view_models_1.CoverageViewModel)
], IncludedCoverageComponent.prototype, "coverage", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], IncludedCoverageComponent.prototype, "highlightCoverage", void 0);
IncludedCoverageComponent = __decorate([
    core_1.Component({
        selector: 'included-coverage',
        template: "<div>     <span class=\"col-xs-8 nopadding\">{{coverage.name}}</span>     <span class=\"col-xs-4 text-right nopadding\">{{coverage.coverageLimitDisplayText}}</span>     <acknowledgements class=\"col-xs-12\"                            [acknowledgements]=\"coverage.acknowledgements\"                            *ngIf=\"coverage.acknowledgements && coverage.acknowledgements.length > 0\">     </acknowledgements> </div>"
    })
], IncludedCoverageComponent);
exports.IncludedCoverageComponent = IncludedCoverageComponent;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/coverages/included-coverage.component.js